export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_01.394d235f.mp4";